import SimpleSelect from 'ui/select';
import { objectDurationTypes } from 'utils/helpers/lists/objectDurationList';

interface TimeSectionProps {
  values: any;
  touched: any;
  errors: any;
  setFieldValue: (field: string, value: any) => void;
  isFieldInherited: (fieldName: string) => boolean;
}

const TimeSection = ({ values, touched, errors, setFieldValue, isFieldInherited }: TimeSectionProps) => {
  return (
    <div className="col-span-full">
      <span className="inline-block Subtitle1 text-smena_text-secondary mb-4">Временное окно для чекина/чекаута</span>
      <div className="grid grid-cols-2 gap-5">
        <SimpleSelect
          divClassName="w-full"
          label="Для чекина"
          placeholder="Выберите тип чекина"
          onChange={value => setFieldValue('checkInMeasurement', value)}
          value={values.checkInMeasurement || objectDurationTypes[0].id}
          error={touched.checkInMeasurement && errors.checkInMeasurement ? errors.checkInMeasurement : ''}
          options={objectDurationTypes}
          sort={false}
          disabled={isFieldInherited('checkInMeasurement')}
        />

        <SimpleSelect
          divClassName="w-full"
          label="Для чекаута"
          placeholder="Выберите тип чекаута"
          onChange={value => setFieldValue('checkOutMeasurement', value)}
          value={values.checkOutMeasurement || objectDurationTypes[0].id}
          error={touched.checkOutMeasurement && errors.checkOutMeasurement ? errors.checkOutMeasurement : ''}
          options={objectDurationTypes}
          sort={false}
          disabled={isFieldInherited('checkOutMeasurement')}
        />
      </div>
    </div>
  );
};

export default TimeSection;
